import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import { ApiContext, buildAPI } from '../../contexts/apiContext';
import { useAppEnvironmentContext } from '../../contexts/appEnvironmentContext';

const queryClient = new QueryClient();

type Props = {
  children: React.ReactNode;
};

const ApiProvider: React.FC<Props> = ({ children }) => {
  const { appEnvironment } = useAppEnvironmentContext();

  return (
    <QueryClientProvider client={queryClient}>
      <ApiContext.Provider value={{ api: buildAPI(appEnvironment) }}>
        {children}
      </ApiContext.Provider>
    </QueryClientProvider>
  );
};

export default ApiProvider;
